<template>
	<div class="app-container space-date-price-page">
		<div class="page-hero">
			<div class="hero-text">
				<h2 class="hero-title">特定日期价格</h2>
				<p class="hero-sub">
					{{ spaceName || '场地' }} · 按单日覆盖「周基础价」，可锁定时段并填写备注；已预定时段不可改价或锁定。
				</p>
			</div>
			<el-button type="success" plain icon="el-icon-back" @click="goBack">返回场地列表</el-button>
		</div>

		<div class="filter-container filter-bar">
			<el-form inline @submit.native.prevent>
				<el-form-item label="指定日期">
					<el-date-picker v-model="listQuery.price_date" type="date" value-format="yyyy-MM-dd" placeholder="筛选日期"
						clearable @change="SearchData" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">查询</el-button>
					<el-button icon="el-icon-refresh" @click="resetFilter">重置</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div class="action-container">
			<el-button v-auth="'SpacePrice.create'" type="primary" icon="el-icon-plus" @click="openCreate">新增配置</el-button>
			<el-button v-auth="'SpacePrice.delete'" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
		</div>

		<el-table ref="singleTable" v-loading="listLoading" :data="list" border stripe class="main-table"
			:header-cell-style="{ background: '#f0f9f4', color: '#303133' }" @sort-change="sortChange">
			<el-table-column type="selection" width="48" align="center" />
			<el-table-column type="index" label="序号" width="60" :index="indexMethod" align="center" />
			<el-table-column prop="price_date" label="配置日期" min-width="120" align="center" sortable="custom" />
			<el-table-column prop="slot_count" label="时段数" width="90" align="center" />
			<el-table-column prop="update_time" label="更新时间" min-width="170" align="center" />
			<el-table-column label="操作" width="200" align="center" fixed="right">
				<template slot-scope="{ row }">
					<el-button v-auth="'SpacePrice.update'" type="primary" size="mini" icon="el-icon-edit"
						@click="openEdit(row)">编辑</el-button>
					<el-button v-auth="'SpacePrice.delete'" type="danger" size="mini" icon="el-icon-delete"
						@click="RowDelete(row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />

		<el-dialog :title="dialogStatus === 'create' ? '新增特定日期配置' : '编辑特定日期配置'" :visible.sync="dialogVisible" width="80%"
			top="3vh" custom-class="date-price-dialog" :close-on-click-modal="false" @closed="onDialogClosed">
			<div v-if="form.price_date" class="dialog-banner">
				<i class="el-icon-info" />
				当前：{{ form.price_date }}
				<span v-if="spaceName"> · {{ spaceName }}</span>
				— 未设置日期时请先选择日期并加载时段；已预定时段不可编辑价格、锁定与备注。
			</div>

			<div class="batch-toolbar">
				<span class="batch-label">批量普通价</span>
				<el-input-number v-model="batchNormal" :min="0" :max="10000" :precision="2" controls-position="right"
					class="batch-num" />
				<span class="batch-label">批量会员价</span>
				<el-input-number v-model="batchVip" :min="0" :max="10000" :precision="2" controls-position="right"
					class="batch-num" />
				<el-button type="primary" plain size="small" @click="applyBatchDay">应用到全天可编辑时段</el-button>
				<el-button type="danger" plain size="small" icon="el-icon-lock" @click="lockAllEditable">锁定全天（可编辑时段）</el-button>
				<el-button type="success" plain size="small" icon="el-icon-unlock"
					@click="unlockAllEditable">解锁全天（可编辑时段）</el-button>
			</div>

			<el-form label-width="100px" class="date-form">
				<el-form-item v-if="dialogStatus === 'create'" label="选择日期" required>
					<el-date-picker v-model="form.price_date" type="date" value-format="yyyy-MM-dd" placeholder="选择要配置的日期"
						@change="onDatePicked" />
					<el-button type="primary" size="small" style="margin-left: 12px" :loading="initLoading"
						:disabled="!form.price_date" @click="loadInit(false)">加载/刷新时段</el-button>
				</el-form-item>
				<el-form-item v-else label="配置日期">
					<el-tag type="info" effect="dark">{{ form.price_date }}</el-tag>
				</el-form-item>
			</el-form>

			<el-table :data="form.slots" border stripe size="small" max-height="480" class="slot-table"
				:header-cell-style="{ background: '#ecf5ff', color: '#303133' }">
				<el-table-column label="时间段" min-width="130" align="center">
					<template slot-scope="{ row }">
						<el-tag type="info" effect="plain">{{ row.start_time }} — {{ row.end_time }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="普通价（元）" min-width="150" align="center">
					<template slot-scope="{ row }">
						<el-input-number v-model="row.normal_price" :min="0" :max="10000" :precision="2" :disabled="row.is_booked"
							controls-position="right" style="width: 130px" />
					</template>
				</el-table-column>
				<el-table-column label="会员价（元）" min-width="150" align="center">
					<template slot-scope="{ row }">
						<el-input-number v-model="row.vip_price" :min="0" :max="10000" :precision="2" :disabled="row.is_booked"
							controls-position="right" style="width: 130px" />
					</template>
				</el-table-column>
				<el-table-column label="锁定" width="150" align="center">
					<template slot-scope="{ row }">
						<el-switch v-model="row.is_lock" :active-value="1" :inactive-value="0" active-text="锁" inactive-text="开"
							:disabled="row.is_booked" />
					</template>
				</el-table-column>
				<el-table-column label="锁场备注" min-width="260" align="center">
					<template slot-scope="{ row }">
						<el-input v-model="row.remark" maxlength="255" show-word-limit placeholder="选填" :disabled="row.is_booked" />
					</template>
				</el-table-column>
				<el-table-column label="场地状态" min-width="120" align="center">
					<template slot-scope="{ row }">
						<el-tag v-if="row.is_booked" type="warning" effect="dark">已预定 · 不可改</el-tag>
						<el-tag v-else type="success" effect="plain">开放配置</el-tag>
					</template>
				</el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" :loading="saveLoading" :disabled="!canSave" @click="submitSave">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import api from '@/api/site/spaceDatePrice'
	import Pagination from '@/components/Pagination'
	import commonList from '@/utils/commonList'

	export default {
		name: 'SpacePrice',
		components: {
			Pagination
		},
		mixins: [commonList],
		data() {
			return {
				api,
				primary_key: 'id',
				spaceId: 0,
				spaceName: '',
				listQuery: {
					page: 1,
					limit: 10,
					sort: 'price_date',
					order: 'DESC',
					price_date: ''
				},
				dialogVisible: false,
				dialogStatus: 'create',
				initLoading: false,
				saveLoading: false,
				batchNormal: null,
				batchVip: null,
				form: {
					id: 0,
					price_date: '',
					slots: []
				}
			}
		},
		computed: {
			canSave() {
				return this.form.price_date && this.form.slots && this.form.slots.length > 0
			}
		},
		created() {
			this.spaceId = parseInt(this.$route.query.space_id, 10) || 0
			this.spaceName = this.$route.query.space_name || ''
			if (!this.spaceId) {
				this.$message.error('缺少场地参数')
				return
			}
			this.loadData()
		},
		methods: {
			loadData() {
				this.listLoading = true
				const data = {
					page: this.listQuery.page,
					limit: this.listQuery.limit,
					sort: this.listQuery.sort,
					order: this.listQuery.order,
					space_id: this.spaceId,
					price_date: this.listQuery.price_date || undefined
				}
				api
					.Query(data)
					.then(res => {
						if (res.code === 200 && res.data) {
							this.list = res.data.items || []
							this.total = res.data.total || 0
						}
					})
					.finally(() => {
						this.listLoading = false
					})
			},
			SearchData() {
				this.listQuery.page = 1
				this.loadData()
			},
			resetFilter() {
				this.listQuery.price_date = ''
				this.SearchData()
			},
			sortChange(param) {
				this.listQuery.page = 1
				if (param.prop) {
					this.listQuery.sort = param.prop
					this.listQuery.order = param.order === 'ascending' ? 'ASC' : 'DESC'
				}
				this.loadData()
			},
			goBack() {
				this.$router.push({
					path: '/site/space'
				})
			},
			openCreate() {
				this.dialogStatus = 'create'
				this.form = {
					id: 0,
					price_date: '',
					slots: []
				}
				this.batchNormal = null
				this.batchVip = null
				this.dialogVisible = true
			},
			openEdit(row) {
				this.dialogStatus = 'update'
				this.batchNormal = null
				this.batchVip = null
				this.initLoading = true
				api
					.EditPayload(row.id)
					.then(res => {
						if (res.code === 200 && res.data) {
							const d = res.data
							this.form = {
								id: d.id,
								price_date: d.price_date,
								slots: this.normalizeSlots(d.slots || [])
							}
							this.dialogVisible = true
						}
					})
					.finally(() => {
						this.initLoading = false
					})
			},
			onDatePicked() {
				this.form.slots = []
			},
			loadInit(silent) {
				if (!this.form.price_date || !this.spaceId) return
				this.initLoading = true
				api
					.InitDay({
						space_id: this.spaceId,
						price_date: this.form.price_date
					})
					.then(res => {
						if (res.code === 200 && res.data) {
							this.form.slots = this.normalizeSlots(res.data.slots || [])
							if (res.data.has_saved && res.data.saved_id) {
								this.form.id = res.data.saved_id
								if (!silent) {
									this.$message.info('该日期已有保存的配置，已载入可继续修改')
								}
							} else {
								this.form.id = 0
							}
						}
					})
					.catch(() => {})
					.finally(() => {
						this.initLoading = false
					})
			},
			normalizeSlots(slots) {
				return (slots || []).map(s => ({
					start_time: s.start_time,
					end_time: s.end_time,
					normal_price: parseFloat(s.normal_price) || 0,
					vip_price: parseFloat(s.vip_price) || 0,
					is_lock: s.is_lock ? 1 : 0,
					remark: s.remark || '',
					is_booked: !!s.is_booked
				}))
			},
			applyBatchDay() {
				if (this.batchNormal == null && this.batchVip == null) {
					this.$message.warning('请至少填写一个批量价格')
					return
				}
				this.form.slots.forEach(row => {
					if (row.is_booked) return
					if (this.batchNormal != null) row.normal_price = this.batchNormal
					if (this.batchVip != null) row.vip_price = this.batchVip
				})
			},
			lockAllEditable() {
				this.form.slots.forEach(row => {
					if (!row.is_booked) row.is_lock = 1
				})
			},
			unlockAllEditable() {
				this.form.slots.forEach(row => {
					if (!row.is_booked) row.is_lock = 0
				})
			},
			payloadSlots() {
				return this.form.slots.map(s => ({
					start_time: s.start_time,
					end_time: s.end_time,
					normal_price: String(s.normal_price != null ? s.normal_price : 0),
					vip_price: String(s.vip_price != null ? s.vip_price : 0),
					is_lock: s.is_lock ? 1 : 0,
					remark: s.remark || ''
				}))
			},
			submitSave() {
				if (!this.canSave) return
				this.saveLoading = true
				const body = {
					space_id: this.spaceId,
					price_date: this.form.price_date,
					slots: this.payloadSlots()
				}
				if (this.form.id) {
					body.id = this.form.id
				}
				api
					.Save(body)
					.then(res => {
						if (res.code === 200) {
							this.$message.success('保存成功')
							this.dialogVisible = false
							this.loadData()
						}
					})
					.finally(() => {
						this.saveLoading = false
					})
			},
			onDialogClosed() {
				this.form = {
					id: 0,
					price_date: '',
					slots: []
				}
			},
			BatchDelete() {
				if (!this.$refs.singleTable.selection.length) {
					this.$message.warning('请选择要删除的记录')
					return
				}
				const ids = this.$refs.singleTable.selection.map(a => a.id)
				this.$confirm('确定删除选中的配置？', '提示', {
						type: 'warning'
					})
					.then(() => {
						api.Delete(ids).then(res => {
							if (res.code === 200) {
								this.$message.success('已删除')
								this.loadData()
							}
						})
					})
					.catch(() => {})
			},
			RowDelete(row) {
				this.$confirm('确定删除该日期的价格配置？', '提示', {
						type: 'warning'
					})
					.then(() => {
						api.Delete([row.id]).then(res => {
							if (res.code === 200) {
								this.$message.success('已删除')
								this.loadData()
							}
						})
					})
					.catch(() => {})
			}
		}
	}
</script>

<style scoped>
	.space-date-price-page {
		background: #f7faf8;
		min-height: calc(100vh - 120px);
		padding-bottom: 24px;
	}

	.page-hero {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding: 20px 22px;
		margin-bottom: 16px;
		background: linear-gradient(135deg, #e8f5e9 0%, #fff 55%, #e3f2fd 100%);
		border-radius: 12px;
		box-shadow: 0 4px 18px rgba(0, 0, 0, 0.06);
		border: 1px solid #e0ebe4;
	}

	.hero-title {
		margin: 0 0 8px;
		font-size: 20px;
		font-weight: 600;
		color: #1f3d2b;
	}

	.hero-sub {
		margin: 0;
		font-size: 13px;
		color: #5a6b5f;
		max-width: 720px;
		line-height: 1.6;
	}

	.filter-bar {
		background: #fff;
		border-radius: 10px;
		padding: 12px 16px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
	}

	.main-table {
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
	}

	.dialog-banner {
		padding: 12px 14px;
		margin-bottom: 14px;
		background: #ecf5ff;
		border: 1px solid #d9ecff;
		border-radius: 8px;
		color: #409eff;
		font-size: 13px;
		line-height: 1.5;
	}

	.dialog-banner i {
		margin-right: 6px;
	}

	.batch-toolbar {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 10px;
		padding: 12px 14px;
		margin-bottom: 14px;
		background: #fafafa;
		border-radius: 8px;
		border: 1px solid #eee;
	}

	.batch-label {
		font-size: 13px;
		color: #606266;
	}

	.batch-num {
		width: 130px;
	}

	.date-form {
		margin-bottom: 8px;
	}

	.slot-table {
		border-radius: 8px;
	}
</style>

<style>
	.date-price-dialog .el-dialog__body {
		padding-top: 10px;
	}
</style>